import React from 'react';

import ChartCantidadPorEstado from './charts/ChartCantidadPorEstado';
import CubejsCard from './CubejsCard';

const CantidadPorEstadoCard = (props) => {
    return (
        <CubejsCard title="Resumen de Prestaciones" {...props}>
            <ChartCantidadPorEstado />
        </CubejsCard>
    );
}

export default CantidadPorEstadoCard;
